var React = require('react');
var scrollTo = require('../../../helpers/scrollTo');

var timer;

class SkipButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      position: 0,
      hidden: false,
      removed: false
    }
    this.progress = this.getCookieValue('progress') || 0;
    this.scrollHandler = this.handleScrollEvent.bind(this);
    this.handleBodyClick = this.handleBodyClick.bind(this);

  }
  componentDidMount() {
    document.addEventListener('scroll', this.scrollHandler);
    document.addEventListener('resize', this.updateLastPosition);
    document.body.addEventListener('click', this.handleBodyClick)
    const height = document.querySelector('.pubr-main').scrollHeight;
    this.setState({
      position: height * (this.progress / 100)
    });
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.scrollHandler);
    document.body.removeEventListener('click', this.handleBodyClick)
  }
  handleScrollEvent(e) {
    if(this.state.hidden === false && window.scrollY > 300) {
        this.setState({ hidden: true });
        setTimeout(() => this.setState({ removed: true }), 500);
    };
    clearTimeout(timer);
    timer = setTimeout(() => {
      var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
      var percentage = (scrollTop / document.body.scrollHeight) * 100;
      if(percentage > 5) {
        document.cookie = `progress=${percentage}`
      }
      else {
        document.cookie = `progress=0`
      }
    }, 150);
  }
  handleBodyClick(e) {
    this.setState({
      hidden: true
    })
  }
  getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }
  handleClick(e) {
    e.stopPropagation();
    scrollTo(this.state.position, 2000);
    this.setState({
      hidden: true
    })
  }
    render() {
    var className = this.state.hidden ? 'pubr-main__last--hidden' : '';
    if(this.state.position > 0 && this.state.removed === false) {
      return <button onClick={this.handleClick.bind(this)} className={`pubr-main__last pubr-action pubr-action--down ${className}`}><span>{this.props.buttonText}</span></button>
    }
    return null;
  }
}

module.exports = SkipButton;



// WEBPACK FOOTER //
// ./src/modules/reader/components/SkipButton.js